import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "./Dashboard";

export const customerLandingRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "/",
}).lazy(() => import("./CustomerLanding.lazy").then((d) => d.Route));
